import apiClient from './apiClient';
import {
  DirectionResponse,
  DirectionUpsertRequest,
  QuestionPageResponse,
  QuestionResponse,
  QuestionUpsertRequest,
  TagResponse,
  TagUpsertRequest,
} from '../../types/types';
import { API_ENDPOINTS } from '../../utils/config/constants';

export type AdminQuestionsQuery = {
  directionId?: number | null;
  tagId?: number | null;
  search?: string | null;
  page?: number;
  size?: number;
  sort?: string;
};

const appendDefined = (params: URLSearchParams, key: string, value: string | number | null | undefined) => {
  if (value !== null && value !== undefined && String(value).trim() !== '') {
    params.set(key, String(value));
  }
};

export const AdminContentApi = {
  getDirections: async () => {
    const response = await apiClient.get<DirectionResponse[]>(API_ENDPOINTS.DIRECTIONS);
    return response.data;
  },

  createDirection: async (request: DirectionUpsertRequest) => {
    const response = await apiClient.post<DirectionResponse>(`${API_ENDPOINTS.ADMIN}/directions`, request);
    return response.data;
  },

  updateDirection: async (id: number, request: DirectionUpsertRequest) => {
    const response = await apiClient.put<DirectionResponse>(`${API_ENDPOINTS.ADMIN}/directions/${id}`, request);
    return response.data;
  },

  deleteDirection: async (id: number) => {
    await apiClient.delete(`${API_ENDPOINTS.ADMIN}/directions/${id}`);
  },

  getDirectionTags: async (directionId: number) => {
    const response = await apiClient.get<TagResponse[]>(`${API_ENDPOINTS.DIRECTIONS}/${directionId}/tags`);
    return response.data;
  },

  createTag: async (request: TagUpsertRequest) => {
    const response = await apiClient.post<TagResponse>(`${API_ENDPOINTS.ADMIN}/tags`, request);
    return response.data;
  },

  updateTag: async (id: number, request: TagUpsertRequest) => {
    const response = await apiClient.put<TagResponse>(`${API_ENDPOINTS.ADMIN}/tags/${id}`, request);
    return response.data;
  },

  deleteTag: async (id: number) => {
    await apiClient.delete(`${API_ENDPOINTS.ADMIN}/tags/${id}`);
  },

  getQuestions: async (query: AdminQuestionsQuery) => {
    const params = new URLSearchParams();
    appendDefined(params, 'directionId', query.directionId);
    appendDefined(params, 'tagId', query.tagId);
    appendDefined(params, 'search', query.search);
    appendDefined(params, 'page', query.page ?? 0);
    appendDefined(params, 'size', query.size ?? 20);
    appendDefined(params, 'sort', query.sort ?? 'title,asc');

    const response = await apiClient.get<QuestionPageResponse>(`${API_ENDPOINTS.ADMIN}/questions?${params.toString()}`);
    return response.data;
  },

  getQuestion: async (id: number) => {
    const response = await apiClient.get<QuestionResponse>(`${API_ENDPOINTS.ADMIN}/questions/${id}`);
    return response.data;
  },

  createQuestion: async (request: QuestionUpsertRequest) => {
    const response = await apiClient.post<QuestionResponse>(`${API_ENDPOINTS.ADMIN}/questions`, request);
    return response.data;
  },

  updateQuestion: async (id: number, request: QuestionUpsertRequest) => {
    const response = await apiClient.put<QuestionResponse>(`${API_ENDPOINTS.ADMIN}/questions/${id}`, request);
    return response.data;
  },

  deleteQuestion: async (id: number) => {
    await apiClient.delete(`${API_ENDPOINTS.ADMIN}/questions/${id}`);
  },
};
